import { mapGetters } from 'vuex'
import Configuration from '@/agilis/util/Configuration'

export default {
  name: 'WorkPackageV3Mixin',

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId'
    }),

    priceListConfiguration () {
      return Configuration.getTrackerType(this.applicationId, 'priceItem').priceList
    },

    workpackages () {
      return Configuration.getTrackerType(this.applicationId, 'proposition').dataTable?.workpackages || {}
    },

    wpTypesAuthorized () {
      let wp = []
      if (this.workpackages) {
        wp = this.workpackages.workPackageTypes.filter((item) =>
          Configuration.auth.userCanAccessFeatureInclude(this.selectedContext, item.id)
        )
      }
      return wp
    },

    wpTypes () {
      return this.workpackages?.workPackageTypes
    }
  },

  methods: {
    matchWpType (wp) {
      const priceListId = wp.priceItem.priceListId
      let wpType = this.wpTypes.find(w => w.priceListId === priceListId)

      // 1st level match not found: check fallbacks
      // TODO: the function below is not recoursive: it will not manage chain of multiple fallbacks
      if (!wpType) {
        const wpTypePriceList = Object.values(this.priceListConfiguration)
          .find(p => p.fallback === priceListId)

        return wpTypePriceList && this.wpTypes.find(w => w.priceListId === wpTypePriceList.id)
      }

      return wpType
    },

    groupName (groupId) {
      if (groupId?.indexOf('#') === 0) { // matching default groupId: #<wpType>#dim1#dim2
        let labelTmp = []
        const tmp = groupId.slice(1).split('#')

        // Get wpType config
        const wpType = this.wpTypes.find(t => t.id === tmp[0])
        const groupingDimensions = wpType?.groupBy || []

        // Build the title looking to the groupBy config of the wpType
        const wpTypeName = wpType ? this.$t(wpType.label) : this.$t('label.unknown')
        if (groupingDimensions.length === 0) {
          labelTmp.push(wpTypeName)
        } else {
          labelTmp.push(wpTypeName + ': ')
          groupingDimensions.forEach((_d, index) => {
            const d = wpType.dimensions.find(d => d.dimension === _d)
            if (d) {
              this.dimensionValueToString(d, tmp[index + 1])
                ? labelTmp.push(this.dimensionValueToString(d, tmp[index + 1]) + ' ') : labelTmp = [this.$t('sales.label.otherProducts')]
            }
          })
        }

        groupId = labelTmp.join('')
      }
      return groupId ? groupId.trim() : '' // in case of custom groupId, let display the value
    },

    defaultGroupId (w) {
      const groupTmp = [] // Array of groupId components
      const wpType = this.wpTypes.find(t => t.id === w.wpType)

      if (wpType) {
        const groupingDimensions = wpType.groupBy || []
        groupTmp.push(w.wpType)
        if (wpType.dimensions) {
          wpType.dimensions.map(d => {
            const tmp = d.wpPath.split('.')
            const value = w[tmp[0]]
            if (groupingDimensions.indexOf(d.dimension) > -1) {
              groupTmp.push((value && typeof value === 'object') ? value.id : value)
            }
          })
        }
      }

      const groupId = groupTmp.includes(null) ? '' : '#' + groupTmp.join('#')
      return this.groupName(groupId)
    },

    dimensionValueToString (dimension, value) {
      switch (dimension?.wpPath) {
        case 'area':
          // TODO recuperare le label dell'area
          return value

        default: return value
      }
    }
  }
}
